module.exports = __webpack_public_path__ + "static/media/money-phone.f7fd787a.png";